function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3.145C1 1.96 1.96 1 3.145 1h9.71C14.04 1 15 1.96 15 3.145v9.71C15 14.04 14.04 15 12.855 15h-9.71A2.144 2.144 0 011 12.855v-9.71zm1.052 8.31v1.4c0 .604.49 1.093 1.093 1.093h9.71c.604 0 1.093-.49 1.093-1.093V9.836l-1.13-1.129a1.092 1.092 0 00-1.544 0l-.912.911 1.247 1.247a.526.526 0 11-.744.744L9.247 9.99 7.154 7.898a1.092 1.092 0 00-1.545 0l-3.557 3.557zm7.566-2.58l-1.72-1.721a2.144 2.144 0 00-3.033 0L2.052 9.967V3.145c0-.604.49-1.093 1.093-1.093h9.71c.604 0 1.093.49 1.093 1.093v5.204l-.385-.386a2.145 2.145 0 00-3.033 0l-.912.912zm-.526-4.112c0-.29.236-.526.526-.526h.009a.526.526 0 010 1.052h-.009a.526.526 0 01-.526-.526z",
  fill: "#2D2D2D"
});
function SvgImagen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Imagen.svg";
export { SvgImagen as ReactComponent };